import { FC, RefObject, useEffect, useState } from 'react';
import { MenuItems } from '../../types/MenuItems';
import { togglePage } from '../../helpers/togglePage';
import cn from 'classnames';
import ls from 'localstorage-slim';

import './Menu.scss';
import { getTranslation } from '../../constants/translations';
import Slider from 'react-slick';

type Props = {
  position: 'absolute' | 'fixed';
  customClassName?: string;
  sliderRef?: RefObject<Slider>;
};

export const Menu: FC<Props> = ({ position, customClassName, sliderRef }) => {
  const { hash } = window.location;
  const [isAnimation, setAnimation] = useState(true);

  const t = getTranslation();

  const handleBtnClick = (id: string, index: number) => {
    ls.set('isMenuOpen', true);

    if (window.screen.width < 0) {
      if (sliderRef) {
        sliderRef.current?.slickGoTo(index);
        togglePage('#menu-' + ++index);
      }
    } else {
      togglePage('#' + id);
    }
  };

  useEffect(() => {
    window.setTimeout(() => {
      setAnimation(false);
    }, 6200);
  }, []);

  return (
    <nav
      className={cn(`menu ${customClassName}`, {
        'menu-animation':
          position === 'fixed' &&
          !customClassName?.includes('menu--horizontal'),
        'mobile-menu-animation':
          position === 'fixed' && customClassName?.includes('menu--horizontal'),
      })}
      style={{ position }}
      id="menu"
    >
      <button
        className={cn(
          'menu__button menu__button--register menu-button _blockLogoHover',
          {
            [`menu-button--active`]: hash.includes(MenuItems.REGISTER),
            [`menu-button-horizontal--active`]:
              hash.includes(MenuItems.REGISTER) && window.screen.width < 990,
          },
        )}
        style={{ animation: `${isAnimation ? '' : 'none'}` }}
        onClick={() => handleBtnClick(MenuItems.REGISTER, 0)}
      >
        <span>{t.REGISTER.Begin}</span>
      </button>
      <button
        className={cn(
          'menu__button menu__button--together menu-button _blockLogoHover',
          {
            [`menu-button--active`]: hash.includes(MenuItems.TOGETHER),
            [`menu-button-horizontal--active`]:
              hash.includes(MenuItems.TOGETHER) && window.screen.width < 990,
          },
        )}
        style={{ animation: `${isAnimation ? '' : 'none'}` }}
        onClick={() => handleBtnClick(MenuItems.TOGETHER, 1)}
      >
        <span>{t.TOGETHER['Do it together?']}</span>
      </button>
      <button
        className={cn(
          'menu__button menu__button--login menu-button _blockLogoHover',
          {
            [`menu-button--active`]: hash.includes(MenuItems.LOGIN),
            [`menu-button-horizontal--active`]:
              hash.includes(MenuItems.LOGIN) && window.screen.width < 990,
          },
        )}
        style={{ animation: `${isAnimation ? '' : 'none'}` }}
        onClick={() => handleBtnClick(MenuItems.LOGIN, 2)}
      >
        <span>{t.LOGIN.login}</span>
      </button>
    </nav>
  );
};
